<template>
    <div class="zixun">
        <!-- 网页title设置 -->
        <!-- <div v-wechat-title="$route.meta.title" img-set="/public/favicon.ico"></div> -->
        <!-- 路由出口 -->
        <DownApp ref="downApp" v-if="$route.path!='/audio/list'"/>
        <DownModal ref="downModal" />
        <g-player ref="player" />
        <router-view v-wechat-title="title"></router-view>
        <!-- 首页底部TabBar -->
        <van-tabbar
            route
            v-model="active"
            :border="false"
            active-color="rgba(255, 76, 103, 1)"
            :inactive-color="
                currentRoute === 'comment' ? '#fff' : 'rgba(34, 34, 34, 1)'
            "
            v-show="$route.meta.navShow == undefined || $route.meta.navShow"
            :style="{
                'background-color':
                    currentRoute === 'comment' ? 'rgba(0,0,0,0)' : '#fff',
                'max-width': '640px',
                margin: '0 auto0',
                left: 'unset',
            }"
            @change="onChange"
        >
            <van-tabbar-item replace to="/">
                <span>资讯</span>
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="props.active || routePath == '/' ? icon0.active : icon0.inactive"
                />
            </van-tabbar-item>
            <van-tabbar-item replace to="/main">
                <span
                    :style="{
                        color:
                            routePath == '/main' || routePath == '/main/find'
                                ? '#FF4c67'
                                : routePath == '/patting/comment'
                                ? '#fff'
                                : '#222',
                    }"
                    >发现</span
                >
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="
                        props.active || routePath == '/main/find'
                            ? icon1.active
                            : icon1.inactive
                    "
                />
            </van-tabbar-item>
            <van-tabbar-item replace to="/patting/comment">
                <span
                    :style="{
                        color:
                            routePath == '/patting/comment' ||
                            routePath == '/patting/order' ||
                            routePath == '/patting/all'
                                ? '#FF4c67'
                                : '#222',
                    }"
                    >拍客</span
                >
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="
                        props.active ||
                        routePath == '/patting/order' ||
                        routePath == '/patting/all'
                            ? icon2.active
                            : icon2.inactive
                    "
                />
            </van-tabbar-item>
            <van-tabbar-item>
                <span>直播</span>
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? icon3.active : icon3.inactive"
                />
            </van-tabbar-item>
            <van-tabbar-item>
                <span>我的</span>
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? icon4.active : icon4.inactive"
                />
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import Contents from "@/request/base.default.js";
import DownApp from "@/components/DownApp";
import DownModal from "../../components/DownModal";
import { checkWx, GetQueryValue } from "@/pages/index/custom";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            active: 0,
            icon0: {
                active: require("@/assets/img/tab_consult_s.png"),
                inactive: require("@/assets/img/tab_consult.png"),
            },
            icon1: {
                active: require("@/assets/img/tab_find_s.png"),
                inactive: require("@/assets/img/tab_find.png"),
            },
            icon2: {
                active: require("@/assets/img/tab_patting_s.png"),
                inactive: require("@/assets/img/tab_patting.png"),
            },
            icon3: {
                active: require("@/assets/img/tab_live_s.png"),
                inactive: require("@/assets/img/tab_live.png"),
            },
            icon4: {
                active: require("@/assets/img/icon_my_s.png"),
                inactive: require("@/assets/img/icon_my.png"),
            },
            currentRoute: "",
            wx: null,
            title: "",
            routePath: "",
        };
    },
    components: { DownApp, DownModal },
    methods: {
        ...mapActions({
            initModal: "common/initModal",
            initPlayer: "common/initPlayer",
        }),
        onChange() {
            console.log(this.active);
            let index = this.active;
            if (index === 3) {
                window.location.href =
                    Contents.mainURL + "/app/live/index?is_h5=1";
            } else if (index === 4) {
                window.location.href = Contents.mainURL + "/app/user/center";
            }
        },
    },
    created() {
        console.log("111");
        this.routePath = this.$route.path
        let isWx = checkWx();
        if (isWx) {
            this.$route.meta.navShow = false;
            if (this.$route.path == "/askTopicDet") {
                this.title = decodeURI(GetQueryValue("name").substring(3));
                return false;
            }
            if (this.$route.path == "/main/findList") {
                this.title = decodeURI(GetQueryValue("name"));
                return false;
            }
            this.title = this.$route.meta.title;
        } else {
            // this.$route.meta.navShow = true;
            this.title = this.$route.meta.title;
        }
    },
    mounted() {
        // 句柄初始化
        this.initModal(this.$refs.downModal);
        this.initPlayer(this.$refs.player);
    },
    watch: {
        $route(route) {
            let isWx = checkWx();
            this.routePath = route.path;
            if (isWx) {
                this.$route.meta.navShow = false;
                if (route.path == "/askTopicDet") {
                    this.title = decodeURI(GetQueryValue("name").substring(3));
                    return false;
                }
                if (this.$route.path == "/main/findList") {
                    this.title = decodeURI(GetQueryValue("name"));
                    return false;
                }
                this.title = this.$route.meta.title;
            } else {
                // this.$route.meta.navShow = true;
                this.title = this.$route.meta.title;
            }
            this.currentRoute = this.$route.path.substring(
                this.$route.path.lastIndexOf("/") + 1
            );
        },
    },
};
</script>

<style lang="less" scoped>
@import url("../../assets/font/iconfont.css");
@import url("../../assets/extraFont/iconfont.css");
.van-tabbar-item__icon img {
    height: 22px;
}
</style>
